import { ReactElement } from "react";
import { IconProps } from "./iconPropsTypes";

export default function Decommit({
  height = "24px",
  width = "24px"
}: IconProps): ReactElement {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 21 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#D32F2F"
      />
      <path
        clipRule="evenodd"
        d="M13.9331 5.18311L14.817 6.06699L10.8831 10.0001L14.817 13.9331L13.9331 14.817L10.0001 10.8831L6.06699 14.817L5.18311 13.9331L9.11711 10.0001L5.18311 6.06699L6.06699 5.18311L10.0001 9.11711L13.9331 5.18311Z"
        fill="white"
        fillRule="evenodd"
      />
      <title>decommit</title>
    </svg>
  );
}
